import { logAmplitudeClickEvent } from 'chairisher/util/analytics';

/**
 * Specifies where a private deal accept originated
 *
 * @enum {string}
 */
export const PrivateDealSource = {
    PDP: 'PDP',
};

/**
 * Renders a private deal for a product.
 *
 * @param {Object} productsData Collection of product data Objects
 * @param {string=} source Indication of where private deal is rendered
 */
export function renderPrivateDeal(productData, source) {
    const privateDealData = productData.meta.private_deal;

    // expiration details
    document.querySelector('.js-product-private-deal-expiry').textContent = privateDealData.expires_in;

    // price details
    document.querySelector('.js-product-price-current-value').textContent = privateDealData.price.display;
    document.querySelector('.js-product-price-previous-value').textContent = productData.meta.your_price.current.value;

    // link href to accept offer
    const ctaLink = document.querySelector('.js-product-private-deal-accept-link');
    const href = source ? `${privateDealData.cta_url}&source=${source}` : privateDealData.cta_url;
    ctaLink.setAttribute('href', href);
    ctaLink.addEventListener('click', () => logAmplitudeClickEvent('Accept Private Deal', source, href));

    document.querySelector('.js-product-private-deal-container').classList.remove('hidden');
}
